export default function() {
    const readMoreButtons = document.querySelectorAll('[read-more-btn]')

    readMoreButtons.forEach(button => {
        const paragraph = button.previousElementSibling
        if (paragraph.scrollHeight > paragraph.clientHeight) button.classList.toggle('hidden')
    })
}